module.exports = __webpack_public_path__ + "static/media/gen_img27.0f1a2190.png";